import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {IBonusSymbolQueue} from "../../server/data/IBonusSymbolQueue";
import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-10-22.
 */

export class BonusBunniesB5WinView extends BaseView {

    protected _layer:ScalableLayer;
    private _valueText:PIXI.BitmapText;
    private _spineB5Presentation:PIXI.spine.Spine;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._spineB5Presentation = new PIXI.spine.Spine(GameResources.getSpineAsset("SpineB5"));
        this._spineB5Presentation.visible = false;
        this.addChild(this._spineB5Presentation);

        this._valueText = new PIXI.BitmapText("", {
            fontName: BonusBunniesGameConfig.TEXT_STYLES.B5_WIN_BITMAP_STYLE.font.name!,
            fontSize: BonusBunniesGameConfig.TEXT_STYLES.B5_WIN_BITMAP_STYLE.font.size,
        });
        this._valueText.anchor = new PIXI.Point(0.5, 0.5);
        this._valueText.alpha = 0;
        this._valueText.visible = false;
        this.addChild(this._valueText);
    }

    public playB5IdleAnimation(reel:number, row:number):void{
        this._spineB5Presentation.position.x = Helper.getSymbolPositions(reel, row)[0];
        this._spineB5Presentation.position.y = Helper.getSymbolPositions(reel, row)[1];
        this._spineB5Presentation.updateTransform();
        this._spineB5Presentation.visible = true;
        this._spineB5Presentation.state.setAnimation(0, "loop", true);
    }

    public b5WinAnimation(b5Win:IBonusSymbolQueue):TimelineLite {
        const b5WinTL:TimelineLite = new TimelineLite();
        b5WinTL.add(() => this._spineB5Presentation.position.x = Helper.getSymbolPositions(b5Win.reelPos, b5Win.rowPos)[0]);
        b5WinTL.add(() => this._spineB5Presentation.position.y = Helper.getSymbolPositions(b5Win.reelPos, b5Win.rowPos)[1]);
        b5WinTL.add(() => this._spineB5Presentation.updateTransform());
        b5WinTL.add(() => this._spineB5Presentation.visible = true);
        b5WinTL.add([
            () => this._spineB5Presentation.state.setAnimation(0, "trigger", false),
            () => BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.disableInfo()
        ]);
        b5WinTL.add(() => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPController.isB5Win = true);
        b5WinTL.add(BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.getChestWinTimeline(b5Win.startMultiplier), "+=1");
        b5WinTL.add(new TimelineLite({delay : 1}));

        return b5WinTL;
    }

    public removeB5Win():void {
        this._valueText.visible = false;
        this._valueText.alpha = 0;
        this._spineB5Presentation.visible = false;
    }
}